const main = {
  'App Description': 'current merchant: {{merchantName}}',
};

export default main;
